import axios from 'axios';

// Clientes HTTP del backend (ver REFACTOR_FRONTEND.md §5.4).
// - `api`: endpoints públicos (catálogo, categorías, login, verificar/refrescar token).
// - `authApi`: endpoints con sesión; agrega `Authorization: JWT <access>` leyendo el token en cada petición.
// Los públicos no llevan el token a propósito: con un token vencido, el backend rechazaría la petición.
export const API_URL = process.env.REACT_APP_API_URL;

// URL absoluta de un archivo que sirve el backend (imágenes de productos); sin ruta devuelve null.
export const mediaUrl = path => (path ? `${API_URL}${path}` : null);

export const api = axios.create({ baseURL: API_URL });

export const authApi = axios.create({ baseURL: API_URL });

// Error que no dice nada sobre la validez de la sesión: sin respuesta (sin red / backend caído),
// demasiadas peticiones (429, throttling del backend) o fallo del servidor (5xx).
export const isTransientError = err => !err.response || err.response.status === 429 || err.response.status >= 500;

// `synchronous`: la petición sale en el mismo instante que antes de tener interceptor (axios no la difiere).
authApi.interceptors.request.use(config => {
    config.headers.Authorization = `JWT ${localStorage.getItem('access')}`;
    return config;
}, null, { synchronous: true });
